<template>
  <div class="pwc-survey-info">
    <!-- <van-nav-bar title="问卷调查" fixed /> -->
    <pwc-container class="survey-container">
      <van-image class="logo" :src="require('../../../assets/logo.png')" />
      <van-image v-if="!submited && data.Image && !data.isLargeImage" style="max-width: 100%; height: 200px;" fit="contain" :src="data.Image" /> 
      <template v-if="!submited && data.Image && data.isLargeImage">
          <div v-for="(item,index) in data.Images" :key="index">
            <van-image  style="max-width: 100%;" fit="cover" :src="item" />
          </div>
      </template>
      <div v-if="!submited" class="survey-label-container">
        <h6 class="survey-title">{{ data.Title }}</h6>
        <!-- eslint-disable-next-line -->
        <span v-if="data.Description" class="survey-desc" v-html="data.Description.replace(/\n/gm, '<br/>')" />
      </div>
      <DyForm v-if="!submited" ref="dyform" :data="data" :surveyType="surveyType" :surveyId="surveyId" :delay="!needLogin" :form-data="formData" @applyStatus="getApplyStatus"  @submited="getSubmited"  :file-keys="fileKeys" @submitForm="(val) => {submitForm(val)}" />
      <div v-else class="success-wrap">
        <success-page ref="success" :data="data" :advanced="showAdvancedThanksPage" :attachment="successAttachment"  :applyStatus="applyStatus"/>
      </div>
      <div v-if="isMobile && !isWechat" style="height: 100px" />
      <!-- <div class="pwc-form-privacy">
        <span>
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
      </div> -->
    </pwc-container>
    <v-dialog v-if="showVerifyDialog" v-model="showVerifyDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="verifyform" class="pwc-dialog-submit">
          <pwc-phone :phone.sync="verification.phoneNo" :surveyType="surveyType" :surveyId="surveyId" @getShowVerifyDialog="getShowVerifyDialog" @applyStatus="getApplyStatus"  @submited="getSubmited" :disabled="!!userInfo.phoneNo" :code.sync="verification.contryCode"/>
          <pwc-phone-verify :resendable="validatePhone()" :verify-code="handleGetVerifyCode" :code.sync="verification.verificationCode" />
          <div style="font-size: 12px; color: #aaa">验证码会发送至你的手机和邮箱（如已留邮箱）</div>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading.saveNewSurveyAnswerLoading" color="#d04a02" flat="flat" @click="handleVerifyDialogCancel">取消</v-btn>
          <v-btn color="#d04a02" flat="flat" :loading="loading.saveNewSurveyAnswerLoading" @click="handleVerifyDialogConfirm">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showCaptchaDialog" v-model="showCaptchaDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="captchform" class="pwc-dialog-submit">
          <v-layout row>
            <v-flex>
              <v-text-field v-model="captchaObj.answer" validate-on-blur single-line :maxlength="4" label="验证码" required clearable clear-icon="fas fa-times" :rules="[rules.required, rules.captcha]" />
            </v-flex>
            <v-flex>
              <div class="captcha-img"><v-img width="86" height="40" :src="captchaObj.image" @click="GetCaptcha" /></div>
            </v-flex>
          </v-layout>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading.saveAnonymousSurveyAnswerLoading" color="#d04a02" flat="flat" @click="closeAnonymousSurveyAnswer">取消</v-btn>
          <v-btn color="#d04a02" flat="flat" :loading="loading.saveAnonymousSurveyAnswerLoading" @click="submitAnonymousSurveyAnswer">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <van-dialog
      v-model="showWechatPublicAccountQr"
      :title="isWechat?'长按二维码 关注公众号报名':'保存二维码 微信关注报名'"
      :show-confirm-button="!isWechat"
      confirm-button-text="我知道了"
    >
      <img class="public-qr" :src="ypPublicQr">
    </van-dialog>
  </div>
</template>

<script>
import RouterName from '@/constants/route'
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import DyForm from '@/components/PwcDyForm/mobile'
import SuccessPage from '@/views/survey/common/success'
import { Image, NavBar, dialog } from 'vant'
import { common } from '../common/mixin.js'
import { validPhone, validOtherPhone, validRequired, captchaCode } from '@/util/validation'
import ypPublicQr from '@/assets/yp-public-qrcode.png'
import Detect, { isWechat } from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import { wechat } from '@/mixin/index'
import { http } from '@/api'
import { PublicEvent } from '@/api/collection'
export default {
  name: 'SurveyMobile',
  components: {
    PwcContainer,
    DyForm,
    SuccessPage,
    [NavBar.name]: NavBar,
    [Image.name]: Image
  },
  mixins: [common, wechat],
  data() {
    return {
      isWechat,
      isMobile,
      ypPublicQr,
      showWechatPublicAccountQr: false,
      rules: {
        required: validRequired,
        captcha: captchaCode
      }
    }
  },
  created(){
console.log(this.data,'data');
  },
  methods: {
    validPhone,
    validOtherPhone,
    handleReturn() {
      this.$router.replace({
        name: RouterName.home,
        query: {
          active: 'self'
        }
      })
    },
    validatePhone() {
      // eslint-disable-next-line eqeqeq
      if (this.verification.contryCode == 86) {
        return this.validPhone(this.verification.phoneNo)
        // eslint-disable-next-line eqeqeq
      } else if (this.verification.contryCode != 86) {
        return this.validOtherPhone(this.verification.phoneNo)
      }
    },
    getSubmited(val){
      this.submited = val
    },
    getApplyStatus(val){
      this.applyStatus = val
    },
    getShowVerifyDialog(val){
      this.showVerifyDialog = val
    }
  }
}
</script>

<style lang="scss">
.pwc-form-privacy {
  text-align: center;
  font-size: 16px;
  padding-top: 30px;
  padding-bottom: 15px;
  background-color: #fff;
  max-width: 640px;
  margin: auto;
  height: auto;
  width: auto;
  overflow: hidden;
}
.pwc-survey-info {
   font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif !important;
  .survey-container {
    position: relative;
    background-color: #fff;
    padding: 20px;

    .logo {
      width: 100%;
      margin: 0px auto;
      padding: 20px 20px 30px 20px;
    }

    .survey-label-container {
      margin-top: 20px;
      .survey-title {
        font-size: 18px;
        font-weight: normal;
        text-align: center;
      }
      .survey-desc {
        font-size: 14px;
        font-weight: normal;
        text-align: left;
        line-height: 22px;
        display: inline-block;
        margin-bottom: 20px;
      }
    }
  }
}

.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
  }
  50% {
    opacity: 0; /*中间状态 透明度为0*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
  }
}

.success-wrap {
  padding-top: 20px;
  text-align: left;
}
.captcha-img {
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}

.public-qr {
    display: block;
    margin: auto;
    width: 100px;
    height: 100px;
    margin-top: 16px;
    margin-bottom: 16px;
}
.van-overlay {
  user-select: none;
}
.van-dialog {
  user-select: none;
}
</style>
